function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.2643 238.657C105.444 251.093 121.345 255.354 133.781 248.174L213.851 201.945C222.684 196.846 225.71 185.552 220.611 176.719C215.511 167.887 204.217 164.861 195.385 169.96L92.7977 229.189L98.2643 238.657Z",
  fill: "#BAC1D1"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M212.529 323.702C214.189 326.578 217.867 327.564 220.743 325.903C223.62 324.243 224.605 320.565 222.945 317.689L166.397 219.745L155.981 225.758L212.529 323.702Z",
  fill: "#DEE7EE"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M154.2 241.18C155.602 243.609 158.708 244.441 161.137 243.038L178.781 232.852C181.21 231.449 182.042 228.343 180.64 225.915C179.237 223.486 176.132 222.653 173.703 224.056L156.059 234.243C153.63 235.645 152.797 238.751 154.2 241.18Z",
  fill: "#D1D8E5"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.78905 83.6882C3.93499 75.2807 6.8156 64.5301 15.2231 59.676C23.6305 54.822 34.3811 57.7026 39.2352 66.1101L124.626 214.011L94.1795 231.589L8.78905 83.6882Z",
  fill: "#DEE7EE"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M185.223 320.823C183.693 318.173 184.601 314.785 187.251 313.255L226.529 290.578C229.179 289.048 232.567 289.956 234.097 292.605L185.223 320.823Z",
  fill: "#DEE7EE"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M188.066 312.787L202.144 337.171C203.038 338.719 202.507 340.7 200.959 341.594C199.41 342.488 197.43 341.957 196.535 340.409L185.696 321.634C183.908 318.537 184.969 314.576 188.066 312.787Z",
  fill: "#DEE7EE"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M225.724 291.046L239.801 315.429C240.695 316.978 242.676 317.509 244.224 316.614C245.773 315.72 246.304 313.74 245.41 312.191L234.57 293.417C232.782 290.319 228.821 289.258 225.724 291.046Z",
  fill: "#DEE7EE"
});

var _ref9 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 243.235,
  cy: 313.984,
  rx: 6.47613,
  ry: 6.4633,
  transform: "rotate(-30 243.235 313.984)",
  fill: "#DEE7EE"
});

var _ref10 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 199.973,
  cy: 338.963,
  rx: 6.47613,
  ry: 6.4633,
  transform: "rotate(-30 199.973 338.963)",
  fill: "#DEE7EE"
});

var SvgChair1 = function SvgChair1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 289,
    height: 364,
    viewBox: "0 0 289 364",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChair1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chair1.7f6b5840.svg";
export { ForwardRef as ReactComponent };